import { useMutation } from '@tanstack/react-query';
import { agreementsApi } from '@/services/agreements';
import { AgreementsRequest, AgreementsResponse } from '@/types/api';

// Hook for updating architect agreements
export const useUpdateArchitectAgreements = () => {
    return useMutation<AgreementsResponse, Error, { architectId: string; data: AgreementsRequest }>({
        mutationFn: ({ architectId, data }) => agreementsApi.updateArchitectAgreements(architectId, data),
        onSuccess: (data) => {
            console.log('Architect agreements updated successfully:', data);
        },
        onError: (error) => {
            console.error('Failed to update architect agreements:', error);
        },
    });
};

// Hook for updating subcontractor agreements
export const useUpdateSubcontractorAgreements = () => {
    return useMutation<AgreementsResponse, Error, { subcontractorId: string; data: AgreementsRequest }>({
        mutationFn: ({ subcontractorId, data }) => agreementsApi.updateSubcontractorAgreements(subcontractorId, data),
        onSuccess: (data) => {
            console.log('Subcontractor agreements updated successfully:', data);
        },
        onError: (error) => {
            console.error('Failed to update subcontractor agreements:', error);
        },
    });
};
